/*******************************************************************************
 * Copyright (c) 2024 Belltane LLC
 *
 * All rights reserved.
 *
 * Contributors:
 *   Amina Rais - Initial implementation
 *
 * Version: 1.0.0
 *
 *******************************************************************************/

import React from 'react'
 import { Grid } from '@mui/material'
import { makeStyles } from 'tss-react/mui';

import PageHeader from './PageHeader'
import PageFooter from './PageFooter'



const Layout = ({children}) => {

  const {classes} = useStyles()

  return (
    <>
      <div className={classes.layout}>
        <PageHeader />

        <main className={classes.main}>
          <Grid container justify="center">
            <Grid container className={classes.gridInner}>
              <Grid item sm={12}>
                {children}
              </Grid>
            </Grid>
          </Grid>
        </main>

        <PageFooter />
      </div>


    </>
  )

}


const useStyles = makeStyles({ "name": { Layout } })((theme) => ({
  layout: {
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
    background: theme.palette.background.paper,
   },
  main: {
    flex: 1,
    marginTop: '54px',

  },
  gridInner: {
    maxWidth: '100%',



  },


}))
export default Layout
